// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"331":"7727a6315ca8b424","651":"751d08acbfd8d41d"}[chunkId] + ".js";
};